import React from "react";
import { Box, Typography, IconButton } from "@mui/material";
import { useNavigate } from "react-router-dom";
import PropTypes from "prop-types";
import { AiOutlineDoubleRight } from "react-icons/ai"; // Or use any icon you prefer
import styles from "./ReadMoreBox.module.css";

const ReadMoreBox = ({ label, icon: Icon, link }) => {
  const navigate = useNavigate();

  const handleClick = () => {
    console.log("Link Clicked:", link);
    
    navigate(`${link}`);
  };

  return (
    <Box className={styles.readMoreBox} onClick={handleClick}>
      <IconButton className={styles.readMoreIcon}>
        {Icon ? <Icon /> : <AiOutlineDoubleRight />} {/* Fallback to default icon if none provided */}
      </IconButton>
      <Typography className={styles.readMoreLabel}>{label}</Typography>
    </Box>
  );
};

ReadMoreBox.propTypes = {
  label: PropTypes.string.isRequired,
  icon: PropTypes.elementType,
  link: PropTypes.string.isRequired,
};

export default ReadMoreBox;